import { tLongAddress } from "tmt_api/src/types/types.validator";

export const getDefaultAddress = (addresses: tLongAddress[]): tLongAddress => {
  return addresses.find((address) => address.isDefault) || addresses[0];
};
